<template>
        <v-dialog :max-width="Global.MODAL_WIDTH" scrollable persistent v-model="showCompanyModal" @close="close">
        <!--<v-btn @mouseover="setContactJson2" v-if="!onlyTrashed" slot="activator" fab dark small color="primary">-->
            <!--<v-icon dark>add</v-icon>-->
        <!--</v-btn>-->
        <v-card>
            <v-card-title class="mb-0, pb-0">
                <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text class="mx-0, px-0">

            <!--TABS-->
                <v-tabs
                    v-model="active_tab"
                    color="blue-grey darken-2 white--text"
                    dark
                    slider-color="blue-grey darken-1"
                    grow
                >
                    <!--Tab General-->
                    <v-tab :key="'tab_general'" ripple >Geral</v-tab>
                    <v-tab-item :key="'tab_general'" >
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12 sm6 md4 px-2>
                                    <v-text-field
                                        v-model="formCompany.name"
                                        :counter="$v.formCompany.name.$params.maxLength.max"
                                        :error-messages="nameErrors"
                                        @blur="$v.formCompany.name.$touch()"
                                        :disabled="companyShow"
                                        label="Nome*"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4 px-2>
                                    <v-select
                                        v-model="formCompany.types_company_types_id"
                                        item-text="name"
                                        item-value="id"
                                        :error-messages="companyTypeErrors"
                                        @blur="$v.formCompany.types_company_types_id.$touch()"
                                        :disabled="companyShow"
                                        :items="company_types" label="Tipo de entidade*"></v-select>
                                </v-flex>
                                <v-flex xs12 sm6 md4 px-2>
                                    <v-select
                                        v-model="formCompany.types_company_categories_id"
                                        item-text="name"
                                        item-value="id"
                                        :error-messages="companyCategoryErrors"
                                        @blur="$v.formCompany.types_company_categories_id.$touch()"
                                        :disabled="companyShow"
                                        :items="company_categories" label="Categoria de empresa*"></v-select>
                                </v-flex>
                                <v-flex xs12 sm6 md4 px-2>
                                    <v-text-field
                                        type="number"
                                        v-model="formCompany.nif"
                                        item-text="name"
                                        item-value="id"
                                        :loading="nifAvailable===search.searching"
                                        :success="nifAvailable===search.available"
                                        :error="nifAvailable===search.notAvailable"
                                        :append-icon="nifAvailable===search.available ? 'done' : nifAvailable===search.notAvailable ? 'clear' : ''"
                                        :class="nifAvailable===search.available ? 'green--text' : nifAvailable===search.notAvailable ? 'red--text' : ''"
                                        :error-messages="nifErrors"
                                        @blur="CheckCompanyNif(2, formCompany.nif)"
                                        @input="nifAvailable = 0"
                                        :counter="$v.formCompany.nif.$params.maxLength.max"


                                        :disabled="companyShow || canEditSensitiveInfo" label="Nif*"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4 px-2>
                                    <v-select
                                        v-model="formCompany.cities_id"
                                        item-text="name"
                                        item-value="id"
                                        :error-messages="cityErrors"
                                        @blur="$v.formCompany.cities_id.$touch()"
                                        :disabled="companyShow"
                                        :items="cities" label="Cidade*"></v-select>
                                </v-flex>
                                <v-flex xs12 sm6 md4 px-2>
                                    <v-select
                                          v-model="formCompany.active_state"
                                          item-text="name"
                                          item-value="id"
                                          :error-messages="activeStateErrors"
                                          @blur="$v.formCompany.active_state.$touch()"
                                          :disabled="companyShow || canEditSensitiveInfo"
                                          :items="g_active_states" label="Estado*"></v-select>
                                </v-flex>
                                <v-flex xs12 sm6 md4 px-2>
                                    <v-text-field
                                          type="number"
                                          v-model.number="formCompany.fiscal_area_code"
                                          :error-messages="fiscalAreaCodeErrors"
                                          :counter="$v.formCompany.fiscal_area_code.$params.maxLength.max"
                                          @blur="$v.formCompany.fiscal_area_code.$touch()"
                                          :disabled="companyShow" label="Código área fiscal*"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4 px-2>
                                    <v-text-field
                                        v-model="formCompany.address"
                                        :counter="$v.formCompany.address.$params.maxLength.max"
                                        :error-messages="addressErrors"
                                        @blur="$v.formCompany.address.$touch()"
                                        :disabled="companyShow"
                                        label="Endereco"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm12 md12 px-2>
                                    <v-textarea
                                        v-model="formCompany.description"
                                        :counter="$v.formCompany.description.$params.maxLength.max"
                                        :error-messages="descriptionErrors"
                                        @blur="$v.formCompany.description.$touch()"
                                        solo
                                        :disabled="companyShow"
                                        label="Descrição" ></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-tab-item>

                    <!--Bank Accounts-->
                    <v-tab :key="'tab_bank_accounts'" ripple >Contas Bancária</v-tab>
                    <v-tab-item :key="'tab_bank_accounts'" >
                        <v-card flat>
                            <v-card-text>
                                <v-container grid-list-md>
                                    <fieldset>
                                        <legend>Conta Primária:</legend>
                                        <v-layout justify>
                                            <v-flex xs12 sm6 px-2>
                                                <v-autocomplete v-model="formCompany.nib_bi_name"
                                                    :items="bankNames"
                                                    :counter="$v.formCompany.nib_bi_name.$params.maxLength.max"
                                                    :error-messages="nibBiNameErrors"
                                                    @blur="$v.formCompany.nib_bi_name.$touch()"
                                                    :disabled="companyShow"
                                                    label="descrição*"></v-autocomplete>
                                            </v-flex>
                                            <v-flex xs12 sm6 px-2>
                                                <v-text-field v-model="formCompany.nib_bi"
                                                    type="number"
                                                    :error-messages="nibBiErrors"
                                                    :counter="$v.formCompany.nib_bi.$params.maxLength.max"
                                                    @blur="$v.formCompany.nib_bi.$touch()"
                                                    :disabled="companyShow"
                                                    label="número*"></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </fieldset>
                                    <br>
                                    <fieldset>
                                        <legend>Conta Secundária:</legend>
                                        <v-layout justify>
                                            <v-flex xs12 sm6 px-2>
                                                <v-autocomplete v-model="formCompany.nib_bi2_name"
                                                    :items="bankNames"
                                                    :counter="$v.formCompany.nib_bi2_name.$params.maxLength.max"
                                                    :disabled="companyShow"
                                                    label="descrição"></v-autocomplete>
                                            </v-flex>
                                            <v-flex xs12 sm6 px-2>
                                                <v-text-field v-model="formCompany.nib_bi2"
                                                    type="number"
                                                    :counter="$v.formCompany.nib_bi2.$params.maxLength.max"
                                                    :disabled="companyShow"
                                                    label="número"></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </fieldset>
                                </v-container>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <!--Admin User-->

                    <v-tab :key="'tab_admin_user'" ripple >{{selectedCompany.id ? 'Logo' : 'Admin/Logo'}}</v-tab>
                    <v-tab-item :key="'tab_admin_user'" >
                            <v-layout v-if="!selectedCompany.id" wrap class="pa-4">
                                <v-flex xs12 sm6 px-2>
                                    <v-text-field
                                        v-model="formCompany.admin_user.name"
                                        :counter="$v.formCompany.admin_user.name.$params.maxLength.max"
                                        :error-messages="adminUserNameErrors"
                                        @blur="$v.formCompany.admin_user.name.$touch()"
                                        :disabled="companyShow || !isSuperAdminGroup()"
                                        label="Nome*"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 px-2>
                                    <v-text-field
                                        v-model="formCompany.admin_user.bi"
                                        :counter="$v.formCompany.admin_user.bi.$params.maxLength.max"
                                        :error-messages="adminUserBiErrors"
                                        :disabled="companyShow || !isSuperAdminGroup()"


                                        :loading="biAvailable===search.searching"
                                        :success="biAvailable===search.available"
                                        :error="biAvailable===search.notAvailable"
                                        :append-icon="adminUserBiErrors.length > 0 ? 'clear' : biAvailable===search.available ? 'done' : ''"
                                        :class="biAvailable===search.available ? 'purplue--text' : biAvailable===search.notAvailable ? 'red--text' : ''"
                                        @blur="checkDataInUse(2, formCompany.admin_user.bi)"
                                        @input="biAvailable = 0"


                                        label="Num. Documento*"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 px-2>
                                    <v-text-field
                                        v-model="formCompany.admin_user.email"
                                        :counter="$v.formCompany.admin_user.email.$params.maxLength.max"
                                        :error-messages="adminUserEmailErrors"
                                        :disabled="companyShow || !isSuperAdminGroup()"


                                        :loading="emailAvailable===search.searching"
                                        :success="emailAvailable===search.available"
                                        :error="emailAvailable===search.notAvailable"
                                        :append-icon="adminUserEmailErrors.length > 0 ? 'clear' : emailAvailable===search.available ? 'done' : ''"
                                        :class="emailAvailable===search.available ? 'purplue--text' : emailAvailable===search.notAvailable ? 'red--text' : ''"
                                        @blur="checkDataInUse(1, formCompany.admin_user.email)"
                                        @input="emailAvailable = 0"


                                        label="Email*"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 px-2 v-visible="!canEditSensitiveInfo">
                                    <v-text-field
                                        v-model="formCompany.admin_user.password"
                                        :counter="$v.formCompany.admin_user.password.$params.maxLength.max"
                                        :error-messages="adminUserPasswordErrors"
                                        :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                        :type="showPassword ? 'text' : 'password'"
                                        @click:append="showPassword = !showPassword"
                                        @blur="$v.formCompany.admin_user.password.$touch()"
                                        :disabled="companyShow || !isSuperAdminGroup()"
                                        label="Senha*"></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap>
                                <v-flex grow></v-flex>
                                <v-flex xs12 sm6 md6 lg4>
                                    <p style="margin-bottom: 5px; margin-top: 10px; color: dimgrey">Logo Empresa</p>
                                    <image-uploader v-if="showCompanyModal"
                                        :image_path="selectedCompany.image_path"
                                        @onImageUploader="imageUploaderCallback($event)"
                                    ></image-uploader>
                                </v-flex>
                                <v-flex grow></v-flex>
                            </v-layout>
                        </v-tab-item>


                    <!--Tab Contact-->
                    <v-tab :key="'tab_contact'" ripple >Contacto</v-tab>
                    <v-tab-item :key="'tab_contact'" >
                        <v-container>
                            <v-text-field
                                v-model="newContactName"
                                append-outer-icon="done"
                                @click:append-outer="visuallyAddContact"
                                @keyup.enter="visuallyAddContact"
                                label="Novo Contacto"
                                v-if="!companyShow"></v-text-field>

                            <!--Expandable components (Contact list)-->
                            <v-expansion-panel popout :value="formCompany.contacts_json.length === 1 ? 0 :1">
                                <p v-if="active_tab===1 && !formCompany.contacts_json">nenhum contacto adicionado ainda</p>
                                <v-expansion-panel-content
                                    v-for="(contact, index) in formCompany.contacts_json"
                                    :key="index"
                                    :class="index%2 === 1? 'grey lighten-2' : 'grey lighten-3'"
                                >
                                    <div slot="header"><b>{{contact.name}}</b> <span v-if="contact.role"> - {{contact.role}}</span></div>

                                        <div style="padding: 10px; background: white" >
                                            <v-layout wrap>
                                                <v-flex xs12 sm6 px-2>
                                                    <v-text-field
                                                        v-model="contact.role"
                                                        label="Descrição"
                                                        :disabled="companyShow">
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 px-2>
                                                    <v-text-field
                                                        v-model="contact.email"
                                                        label="Email"
                                                        :disabled="companyShow">
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 px-2>
                                                    <v-text-field
                                                        v-model="contact.mobile_phone"
                                                        prefix="(+238)"
                                                        label="Móvel"
                                                        mask="### ## ##"
                                                        :disabled="companyShow">
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 px-2>
                                                    <v-text-field
                                                        v-model="contact.phone"
                                                        label="Telefone"
                                                        prefix="(+238)"
                                                        mask="### ## ##"
                                                        :disabled="companyShow">
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 v-if="!companyShow && index > 0">
                                                    <v-hover>
                                                        <v-btn
                                                            slot-scope="{ hover }"
                                                            :class="'{hover ?  : red}'"
                                                            small flat icon color="grey" @click="visuallyRemoveContact(index)">
                                                            <v-icon>delete</v-icon>
                                                        </v-btn>
                                                    </v-hover>
                                                </v-flex>
                                            </v-layout>
                                        </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-container>
                    </v-tab-item>
                </v-tabs>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn depressed @click="close">Cancelar</v-btn>
                <v-spacer></v-spacer>
                <div v-if="!loading_modal">
                    <v-btn :disabled="active_tab === 0" @click="active_tab = active_tab > 0 ? active_tab-1 : 0">Anterior</v-btn>
                    
                    <v-btn v-if="!companyShow && active_tab !== (TOTAL_TABS-1)"
                       :disabled="checkButtons"
                       color="primary" @click="changeTab()">Seguinte</v-btn>
                    <v-btn v-if="!companyShow && active_tab === (TOTAL_TABS-1)"
                       :disabled="checkButtons"
                       color="primary" @click="save">Guardar</v-btn>
                </div>
                <v-progress-circular v-else indeterminate color="primary" m-2 ></v-progress-circular>
            </v-card-actions>
        </v-card>
        </v-dialog>
</template>

<script>
    import Vue from 'vue';
    import {mapGetters} from 'vuex';
    import {eventBus} from "../../main";
    import ImageUploader from '../image/ImageUploader';
    import {Global} from "../../config";
    import {maxLength, email, minLength, minValue, required} from 'vuelidate/lib/validators'
    export default {
/* eslint-disable */
        name: 'company_form_modal',

        created(){
            let vm = this;
            this.onCompanyFormOpened(vm);
        },
        beforeDestroy(){
            eventBus.$off('onCompanyModalOpen');
        },

        data () {
            return {
                Global,
                ex: {
                    file: '',
                    image: '',
                    isDragging: false,
                    dragCount: 0,
                },

                TOTAL_TABS: 4,
                newContactName: '',
                active_tab: 0,
                loading_modal: false,
                companyImage: null,
                
                search:{
                    searching:1,
                    notAvailable:2,
                    available:3,
                },

                emailAvailable: 0,
                biAvailable: 0,

                //AutoComplete
                isLoading: false,
                searchCompanyField: null,
                canEditSensitiveInfo: false,
                showPassword: false,

                search:{
                    searching:1,
                    notAvailable:2,
                    available:3,
                },

                nifAvailable: 0,
                nibBiAvailable: 0,

                bankNames: [
                    'BCA',
                    'BCN',
                    'BI',
                    'CECV',
                    'EcoBank',
                    'BIC',
                    'BAI',
                ]
            }
        },

        props: {
            v: Object,
        },

        components: {
            ImageUploader
        },

        validations: {
            formCompany: {
                name: {
                    required,
                    minLength: minLength(2),
                    maxLength: maxLength(100),
                },
                types_company_types_id: {
                    required,
                },
                types_company_categories_id: {
                    required,
                },
                nib_bi: {
                    required,
                    maxLength: maxLength(50),
                    minValue: minValue(0),
                },
                nib_bi_name: {
                    required,
                    maxLength: maxLength(100),
                },
                nib_bi2: {
                    maxLength: maxLength(50),
                },
                nib_bi2_name: {
                    maxLength: maxLength(100),
                },
                nif: {
                    maxLength: maxLength(10),
                    minValue: minValue(0),
                    required,
                },
                active_state: {
                    required,
                },
                cities_id: {
                    required,
                },
                address: {
                    maxLength: maxLength(120),
                },
                description: {
                    maxLength: maxLength(250),
                },
                fiscal_area_code: {
                    maxLength: maxLength(20),
                    required,
                },
                admin_user: {
                    name: {
                        maxLength: maxLength(100),
                        required,
                    },
                    bi: {
                        required,
                        maxLength: maxLength(24),
                        minLength: minLength(4),
                    },
                    email: {
                        maxLength: maxLength(120),
                        email,
                        required,
                    },
                    password: {
                        minLength: minLength(6),
                        maxLength: maxLength(40),
                        required,
                    }
                }
            }

        },

        watch: {
            showArticleModal (val) {
                val || this.close()
            },

            searchCompanyField (){
                this.searchCompany(this);
            },

        },

        methods: {
            changeTab(){
                if(this.active_tab === this.TOTAL_TABS){
                    this.active_tab = 0;
                }else{
                    this.active_tab++;
                }
            },

            getContactsJson(item){
                let array = [];
                if(!item.contacts_json) return array;

                let newJsonArray = JSON.stringify(item.contacts_json);

                return JSON.parse(newJsonArray);
            },

            imageUploaderCallback(payload){
                this.companyImage = payload;
            },

            addCompany(){
                this.loading_modal = true;
                Vue.axios.post('company', {
                    name: this.formCompany.name,
                    types_company_types_id: this.formCompany.types_company_types_id,
                    types_company_categories_id: this.formCompany.types_company_categories_id,
                    nib_bi: this.formCompany.nib_bi,
                    nib_bi_name: this.formCompany.nib_bi_name,
                    nib_bi2: this.formCompany.nib_bi2,
                    nib_bi2_name: this.formCompany.nib_bi2_name,
                    nif: this.formCompany.nif,
                    active_state: this.formCompany.active_state,
                    cities_id: this.formCompany.cities_id,
                    address: this.formCompany.address,
                    fiscal_area_code: this.formCompany.fiscal_area_code,
                    contacts_json: JSON.stringify(this.formCompany.contacts_json),
                    description: this.formCompany.description,
                    companyImage: this.companyImage,

                    user_admin_name: this.formCompany.admin_user.name,
                    user_admin_bi: this.formCompany.admin_user.bi,
                    user_admin_email: this.formCompany.admin_user.email,
                    user_admin_password: this.formCompany.admin_user.password,

                    admin_group_permissions: this.getGeneralAdminPermissions(),
                    employees_group_permissions: this.getGeneralEmployeePermissions(),
                })
                .then(response => {
                    this.consoleLog(response);
                    if(!response.data.success){
                        this.handleErrorCodeMessage(response.data);
                        return;
                    }
                    let empresa = response.data.response;
                    eventBus.$emit('onCompanyAdded', empresa, 0);
                    this.showSnackBar('Empresa adicionado com sucesso', 'success');
                    this.close();
                }).catch(error => {
                    this.consoleLog(error);
                    this.showSnackBar('ocorreu um erro. Tente novamente', 'red');
                    eventBus.$emit('onCompanyAdded', null);
                }).finally( ()=> {
                    this.loading_modal = false;
                });
            },

            updateCompany(){
                this.loading_modal = true;
                Vue.axios.put('company/'+this.selectedCompany.id, {
                    name: this.formCompany.name,
                    types_company_types_id: this.formCompany.types_company_types_id,
                    types_company_categories_id: this.formCompany.types_company_categories_id,
                    nib_bi: this.formCompany.nib_bi,
                    nib_bi_name: this.formCompany.nib_bi_name,
                    nib_bi2: this.formCompany.nib_bi2,
                    nib_bi2_name: this.formCompany.nib_bi2_name,
                    nif: this.formCompany.nif,
                    active_state: this.formCompany.active_state,
                    cities_id: this.formCompany.cities_id,
                    address: this.formCompany.address,
                    fiscal_area_code: this.formCompany.fiscal_area_code,
                    contacts_json: JSON.stringify(this.formCompany.contacts_json) ,
                    description: this.formCompany.description,
                    file: this.companyImage,

                    user_admin_name: this.formCompany.admin_user.name,
                    user_admin_bi: this.formCompany.admin_user.bi,
                    user_admin_email: this.formCompany.admin_user.email,
                    user_admin_password: this.formCompany.admin_user.password,

                }).then(response => {
                    this.consoleLog(response);
                    if(!response.data.success){
                        this.handleErrorCodeMessage(response.data);
                        // eventBus.$emit('onCompanyAdded', null);
                        return;
                    }
                    let updatedCompany = response.data.response;
                    eventBus.$emit('onCompanyAdded', updatedCompany, 1);
                    this.showSnackBar('Empresa atualizado com sucesso', 'success');
                    this.close();
                }).catch(error => {
                    this.consoleLog(error);
                    this.showSnackBar('ocorreu um erro. Tente novamente', 'red');
                    // eventBus.$emit('onCompanyAdded', null);
                }).finally( ()=> {
                    this.loading_modal = false;
                });
            },

            resetForm(){
                this.formCompany.name = '';
                this.formCompany.types_company_type = '';
                this.formCompany.types_company_types_id = '';
                this.formCompany.types_company_categories_id = '';
                this.formCompany.nib_bi = '';
                this.formCompany.nif = '';
                this.formCompany.cities_id = '';
                this.formCompany.active_state = '';
                this.formCompany.address = '';
                this.formCompany.description = '';
                this.formCompany.fiscal_area_code = '';
                this.formCompany.contacts_json = [{ name:'Empresa',  phone: '', mobile_phone: '', email: '', role: ''}];

                this.newContactName = '';
            },

            close () {
                this.showCompanyModal = false;
                this.$v.$reset();
                this.resetForm();
                this.active_tab = 0;
                this.emailAvailable = 0;
                this.biAvailable = 0;
                this.nibBiAvailable = '';
                this.nifAvailable = '';
                this.canEditSensitiveInfo = false;

                setTimeout(() => {
                    this.loading = false;
                    this.companyShow = false;
                    // this.selectedIndex = -1;
                    this.selectedCompany = null;
                }, 300);
            },

            save () {
                if (this.selectedCompany.id) {
                    // this.consoleLog('editing');
                    this.updateCompany();
                } else {
                    // this.consoleLog('adding');
                    this.addCompany();
                    // this.consoleLog(JSON.stringify(this.selectedCompany, null, 4));
                }
            },

            CheckCompanyNif(op, data){
                this.consoleLog('checking data in use');
                if(op === 1){
                    this.$v.formCompany.admin_user.email.$touch();
                    if(!data) {
                        this.emailAvailable = 0;
                        return;
                    }
                    this.emailAvailable = this.search.searching;
                }else if(op === 2){
                    this.$v.formCompany.admin_user.bi.$touch();
                    if(!data) {
                        this.nifAvailable = 0;
                        return;
                    }
                    this.nifAvailable = this.search.searching;
                }

                Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                Vue.axios.get('company/data_in_use', {
                    params: {op: op, data: data}
                })
                    .then(response=>{
                        this.consoleLog('data_in_use', response);
                        if(op ===1 ){
                            this.emailAvailable = response.data.success ? this.search.available : this.search.notAvailable;
                        }else if(op === 2){
                            this.nifAvailable = response.data.success ? this.search.available : this.search.notAvailable;
                        }
                    }).catch(error=>{
                    this.consoleLog(error);
                })
            },

            checkDataInUse(op, data){
                this.consoleLog('checking data in use');
                if(op === 1){
                    this.$v.formCompany.admin_user.email.$touch();
                    if(!data) {
                        this.emailAvailable = 0;
                        return;
                    }
                    this.emailAvailable = this.search.searching;
                }else if(op === 2){
                    this.$v.formCompany.admin_user.bi.$touch();
                    if(!data) {
                        this.biAvailable = 0;
                        return;
                    }
                    this.biAvailable = this.search.searching;
                }

                Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                Vue.axios.get('user/data_in_use', {
                    params: {op: op, data: data}
                })
                    .then(response=>{
                        this.consoleLog('data_in_use', response);
                        if(op ===1 ){
                            this.emailAvailable = response.data.success ? this.search.available : this.search.notAvailable;
                        }else if(op === 2){
                            this.biAvailable = response.data.success ? this.search.available : this.search.notAvailable;
                        }
                    }).catch(error=>{
                    this.consoleLog(error);
                })
            },

            visuallyAddContact(){
                if(this.newContactName === '') return;
                let contact = {

                    name: this.role ? this.newContactName+' - '+this.role : this.newContactName,
                    role: this.role ? this.role : "",
                    email: this.email ? this.email : "",
                    mobile_phone: this.mobile_phone ? this.mobile_phone : "",
                    phone: this.phone ? this.phone : "",


                };
                if(!this.formCompany.contacts_json){
                    this.formCompany.contacts_json = [];
                }
                this.formCompany.contacts_json.splice(1, 0, contact);
                this.newContactName = '';
            },

            visuallyRemoveContact(index){
                this.formCompany.contacts_json.splice(index, 1);
            },

            onCompanyFormOpened(vm){
                eventBus.$on('onCompanyModalOpen', function (bool, canEditSensitiveInfo) {
                    // this.consoleLog('CompanyModalOpened');
                    vm.canEditSensitiveInfo = canEditSensitiveInfo;

                    if(!vm.selectedCompany.id){
                        vm.formCompany.contacts_json = [{ name:'Empresa',  phone: '', mobile_phone: '', email: '', role: ''}];
                    }
                });
            },

        },


        computed: {
            ...mapGetters([
                'getToken',
                'loggedUser',
            ]),
            showCompanyModal: {
                get(){
                    return this.$store.getters.getShowCompanyModal;
                },
                set(value){
                    this.$store.dispatch('setShowCompanyModal', value);
                }
            },
            selectedCompany: {
                get(){
                    return this.$store.getters.getSelectedCompany;
                },
                set(value){
                    this.$store.dispatch('setSelectedCompany', value);
                }
            },
            formCompany: {
                get(){
                    return this.$store.getters.getFormCompany;
                },
                set(value){
                    this.$store.dispatch('setFormCompany', value);
                }
            },
            companyShow: {
                get(){
                    return this.$store.getters.getCompanyShow;
                },
                set(value){
                    this.$store.dispatch('setCompanyShow', value);
                }
            },
            cities: {
                get(){
                    return this.$store.getters.getGCities;
                },
                set(value){
                    this.$store.dispatch('setGCities', value);
                }
            },
            company_types: {
                get(){
                    return this.$store.getters.getGCompanyTypes;
                },
                set(value){
                    this.$store.dispatch('setGCompanyTypes', value);
                }
            },
            company_categories: {
                get(){
                    return this.$store.getters.getGCompanyCategories;
                },
                set(value){
                    this.$store.dispatch('setGCompanyCategories', value);
                }
            },
            g_active_states() {
                return this.$store.getters.getGActiveStates;
            },

            displayCompanyUsersTab(){
                return !!this.selectedCompany.id || this.companyShow;
            },

            checkButtons(){
                // let nib_bi_bool = this.nibBiAvailable !== this.search.available;
                let nif_bool = this.nifAvailable !== this.search.available;

                let isOk = true;

                if(this.selectedCompany.id){
                    // nib_bi_bool = (this.selectedCompany.nib_bi !== this.formCompany.nib_bi) && (this.nibBiAvailable !== this.search.available);
                    nif_bool = (this.selectedCompany.nif !== this.formCompany.nif) && (this.nifAvailable !== this.search.available);
                }

                isOk = this.checkFirstTab;
                if(this.active_tab === 1){
                    isOk = this.checkSecondTab;
                }else if(this.active_tab === 2){
                    isOk = this.checkThirdTab;
                }
                // return isOk;

                return (isOk || nif_bool);
            },

            checkSecondTab(){
                return this.$v.formCompany.nib_bi.$invalid || this.$v.formCompany.nib_bi_name.$invalid;
            },

            checkFirstTab(){
                return this.$v.formCompany.name.$invalid || this.$v.formCompany.types_company_types_id.$invalid ||
                        this.$v.formCompany.types_company_categories_id.$invalid ||
                        this.$v.formCompany.nif.$invalid || this.$v.formCompany.active_state.$invalid ||
                        this.$v.formCompany.cities_id.$invalid || this.$v.formCompany.address.$invalid ||
                        this.$v.formCompany.description.$invalid || this.$v.formCompany.fiscal_area_code.$invalid;
            },

            checkThirdTab(){
                if(this.selectedCompany.id) return false;
                return this.$v.formCompany.admin_user.name.$invalid || this.$v.formCompany.admin_user.bi.$invalid ||
                        this.$v.formCompany.admin_user.email.$invalid || this.$v.formCompany.admin_user.password.$invalid 
                        || this.emailAvailable!==this.search.available || this.biAvailable!==this.search.available;
            },

            formTitle () {
                return this.companyShow ? 'Empresa' : (this.selectedCompany.id ? 'Editar Empresa' : 'Nova Empresa');
            },
            
            nameErrors () {
                const errors = [];
                if (!this.$v.formCompany.name.$dirty) return errors;
                // !this.$v.formCompany.name.decimal && errors.push('Name must be a number')
                !this.$v.formCompany.name.minLength && errors.push('Mínino de 2 caracteres');
                !this.$v.formCompany.name.maxLength && errors.push('Máximo de 100 caracteres');
                !this.$v.formCompany.name.required && errors.push('Digite um nome');
                return errors
            },
            companyTypeErrors () {
                const errors = [];
                if (!this.$v.formCompany.types_company_types_id.$dirty) return errors;
                !this.$v.formCompany.types_company_types_id.required && errors.push('Escolha tipo de empresa');
                return errors
            },
            companyCategoryErrors () {
                const errors = [];
                if (!this.$v.formCompany.types_company_categories_id.$dirty) return errors;
                !this.$v.formCompany.types_company_categories_id.required && errors.push('Escolha uma categoria');
                return errors
            },
            nibBiErrors () {
                const errors = [];
                if (!this.$v.formCompany.nib_bi.$dirty) return errors;
                !this.$v.formCompany.nib_bi.minValue && errors.push('Introduza valores não negativos');
                !this.$v.formCompany.nib_bi.maxLength && errors.push('Maximo de 50 caracteres');
                !this.$v.formCompany.nib_bi.required && errors.push('Introduza Nib');
                return errors
            },
            nibBiNameErrors () {
                const errors = [];
                if (!this.$v.formCompany.nib_bi_name.$dirty) return errors;
                !this.$v.formCompany.nib_bi_name.maxLength && errors.push('Maximo de 100 caracteres');
                !this.$v.formCompany.nib_bi_name.required && errors.push('Introduza Nib');
                return errors
            },
            nifErrors () {
                const errors = [];
                if (!this.$v.formCompany.nif.$dirty) return errors;
                !this.$v.formCompany.nif.minValue && errors.push('Introduza valores não negativos');
                !this.$v.formCompany.nif.maxLength && errors.push('Maximo de 10 caracteres');
                !this.$v.formCompany.nif.required && errors.push('Introduza nif');
                this.nifAvailable === this.search.notAvailable && errors.push('Este Nif se encontra em uso');
                return errors
            },
            activeStateErrors () {
                const errors = [];
                if (!this.$v.formCompany.active_state.$dirty) return errors;
                !this.$v.formCompany.active_state.required && errors.push('Escolha um estado');
                return errors
            },
            cityErrors () {
                const errors = [];
                if (!this.$v.formCompany.cities_id.$dirty) return errors;
                !this.$v.formCompany.cities_id.required && errors.push('Escolha uma cidade');
                return errors
            },
            addressErrors () {
                const errors = [];
                if (!this.$v.formCompany.address.$dirty) return errors;
                // !this.$v.formCompany.name.decimal && errors.push('Name must be a number')
                !this.$v.formCompany.address.maxLength && errors.push('Maximo de 120 caracteres');
                return errors
            },
            descriptionErrors () {
                const errors = [];
                if (!this.$v.formCompany.description.$dirty) return errors;
                // !this.$v.formCompany.name.decimal && errors.push('Name must be a number')
                !this.$v.formCompany.description.maxLength && errors.push('Maximo de 250 caracteres');
                return errors
            },
            fiscalAreaCodeErrors () {
                const errors = [];
                if (!this.$v.formCompany.fiscal_area_code.$dirty) return errors;
                !this.$v.formCompany.fiscal_area_code.maxLength && errors.push('Maximo de 20 caracteres');
                !this.$v.formCompany.fiscal_area_code.required && errors.push('introduza cod. área fiscal');
                return errors
            },

            //Admin user
            adminUserNameErrors(){
                const errors = [];
                if (!this.$v.formCompany.admin_user.name.$dirty) return errors;
                !this.$v.formCompany.admin_user.name.required && errors.push('introduza um nome');
                return errors
            },
            adminUserBiErrors(){
                const errors = [];
                if (!this.$v.formCompany.admin_user.bi.$dirty) return errors;
                !this.$v.formCompany.admin_user.bi.required && errors.push('introduza Número de documento');
                !this.$v.formCompany.admin_user.bi.minLength && errors.push('Mínimo 4');
                !this.$v.formCompany.admin_user.bi.maxLength && errors.push('Máximo 24');
                this.biAvailable === this.search.notAvailable && errors.push('Este Num. Documento se encontra em uso');
                return errors
            },
            adminUserEmailErrors(){
                const errors = [];
                if (!this.$v.formCompany.admin_user.email.$dirty) return errors;
                !this.$v.formCompany.admin_user.email.email && errors.push('Introduza um email válido');
                !this.$v.formCompany.admin_user.email.required && errors.push('Introduza um email');
                this.emailAvailable === this.search.notAvailable && errors.push('Este e-mail se encontra em uso');
                return errors
            },
            adminUserPasswordErrors(){
                const errors = [];
                if (!this.$v.formCompany.admin_user.password.$dirty) return errors;
                !this.$v.formCompany.admin_user.password.minLength && errors.push('Mínimo 6');
                !this.$v.formCompany.admin_user.password.maxLength && errors.push('Máximo 40');
                !this.$v.formCompany.admin_user.password.required && errors.push('introduza uma senha');
                return errors
            },
        },


    }
</script>


<style scoped>
fieldset {
    border: 1px solid silver;
    padding: 8px;    
    border-radius: 4px;
}
legend{
    padding: 2px;
    color: rgb(152, 156, 152);
}
</style>